<template>
  <b-section-loader :loading="loading">
    <div v-if="items.length" class="status-history-timeline">
      <div v-for="item in items" :key="item.id" class="status-history-item">
        <div class="status-history-marker text-blue-darken-3"></div>

        <div class="font-size-14 text-grey-darken-4">
          <span>{{ item.oldStatus?.name || '—' }}</span>
          <v-icon
            class="mx-1"
            color="grey-darken-1"
            icon="mdi-arrow-right-thin"
            size="16"></v-icon>
          <span>{{ item.newStatus?.name || '—' }}</span>
        </div>

        <div class="font-size-12 text-disabled mt-1">
          {{
            item.responsible
              ? getPersonName(item.responsible) || item.responsible.name || '—'
              : '—'
          }}
          ·
          {{ new CustomDate(item.created_at).toString({ time: true }) }}
        </div>

        <div v-if="item.comment" class="font-size-12 text-medium-emphasis mt-1">
          <span>Коментар:</span>
          {{ item.comment }}
        </div>
      </div>
    </div>

    <empty-section
      v-else
      description="Нових записів наразі не було"
      title="Історія статусів порожня"></empty-section>
  </b-section-loader>
</template>

<script setup lang="ts">
import EmptySection from '@/components/EmptySection.vue'
import { BSectionLoader } from 'best-modules/components'
import { CustomDate, getPersonName } from 'best-modules/utils'
import type { StatusHistoryRow } from '@/requests/history'

defineOptions({
  name: 'StatusHistoryList',
})

defineProps<{
  items: StatusHistoryRow[]
  loading?: boolean
}>()
</script>

<style lang="scss" scoped>
.status-history-timeline {
  position: relative;
  padding-left: 42px;
}

.status-history-timeline::before {
  position: absolute;
  top: 9px;
  bottom: 9px;
  left: 8px;
  width: 3px;
  background: rgba(var(--v-theme-on-surface), 0.08);
  content: '';
}

.status-history-item {
  position: relative;
  padding-bottom: 15px;
}

.status-history-item:last-child {
  padding-bottom: 0;
}

.status-history-marker {
  position: absolute;
  top: 0;
  left: -42px;
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-radius: 50%;
  background: rgb(var(--v-theme-surface));
}
</style>
